<template>
    <div class="nav-body row">
        <div class="col col-12 col-lg-3 col-xxl-2">
            <div class="mobile-nav clearfix" v-if="firstLink !== null">
                <router-link class="nav-link"
                             :to="firstLink.route"
                             role="tab"
                             v-if="visible(firstLink)"
                >
                    <font-awesome-icon :icon="firstLink.icon"
                                       v-if="firstLink.icon !== undefined && firstLink.icon !== null"
                    />
                    {{firstLink.name}}
                </router-link>
                <button type="button"
                        class="btn btn-menu btn-secondary"
                        @click="toggledResponsive = !toggledResponsive"
                >
                    <font-awesome-icon icon="bars"/>
                    {{t('Menu')}}
                </button>
            </div>


            <div class="nav flex-column nav-pills"
                 :class="{'opened': toggledResponsive}"
                 role="tablist"
                 aria-orientation="vertical"
            >
                <router-link
                        v-for="(link, index) in links"
                        class="nav-link"
                        :key="index"
                        :to="link.route"
                        role="tab"
                        v-if="visible(link)"
                >
                    <font-awesome-icon :icon="link.icon" v-if="link.icon !== undefined && link.icon !== null"/>
                    {{link.name}}
                </router-link>
            </div>
        </div>
        <div class="col col-12 col-lg-9 col-xxl-10" :class="{'disabled-content': toggledResponsive}">
            <slot/>
        </div>
    </div>
</template>
<script>
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faBars} from '@fortawesome/free-solid-svg-icons'

    library.add(faBars);

    export default {
        props: {
            links: {
                type: Array,
                default: []
            },
            openFirst: {
                type: Boolean,
                default: false,

            },
            routerParam: {
                type: String,
                'default': 'type',
            },
            routerName: {
                type: String,
                'default': 'viewContent',
            }
        },
        computed: {
            firstLink() {
                let found = this.links.find(link => {
                    return this.visible(link) ? link : false;
                });
                return found === undefined ? null : found;
            }
        },
        created() {
            this.setPage();
        },
        watch: {
            '$route'() {
                this.setPage();
            }
        },
        methods: {
            visible(item) {
                const visible = item.visible === undefined ? true : item.visible;
                return typeof visible === 'function' ? visible() : visible;
            },
            setPage() {
                let found = this.links.find(item => {
                    return item.route.params[this.routerParam] === this.$route.params[this.routerParam];
                });

                if (this.openFirst && found === undefined) {
                    this.$router.push(this.links[0].route);
                }
                if (found !== undefined) {
                    this.$emit('changeTitle', found.name);
                }
            }
        },
        data() {
            return {
                toggledResponsive: false,
            };
        }
    }
</script>
<style lang="scss">

    $breakPoint: 992px;


    .nav-body {
        .mobile-nav {
            background: #fff;
            border-radius: 5px;
            position: relative;
            margin-bottom: 7px;
            border: 1px solid rgba(0, 0, 0, 0.125);

            a.nav-link {
                color: #000;
                float: left;
                width: 70%;
            }

            .btn-menu {
                float: left;
                width: 30%;
            }
        }

        @media (min-width: $breakPoint) {
            .mobile-nav {
                display: none;
            }
        }
        @media (max-width: $breakPoint - 1px) {
            .nav {
                margin-bottom: 15px;
                &:not(.opened) {
                    display: none;
                }
            }

            .disabled-content {
                display: none;
            }
        }


        .nav.nav-pills {
            margin-bottom: 20px;

            &.nav-pills-tabs {
                > li {
                    &:first-child > a {
                        border-radius: 5px 0 0 5px;
                    }

                    &:last-child > a {
                        border-radius: 0 5px 5px 0;
                        border-bottom-width: 0;
                    }
                }

            }

            &:not(.nav-pills-tabs) {
                a {
                    &:first-child {
                        border-radius: 4px 4px 0 0;
                    }

                    &:last-child {
                        border-radius: 0 0 4px 4px;
                        border-bottom-width: 0;
                    }
                }
            }

            background: #fff;
            border: 1px solid rgba(0, 0, 0, 0.125);
            border-radius: 5px;

            a {
                &:not(.active) {
                    color: #000;
                }
                border-bottom: 1px solid rgba(0, 0, 0, 0.125);
                border-radius: 0;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/admin/Layout/NavBody.vue